<template>
  <div>
    <div class="az-form-content">
      <painel-documento-solicitado-visualizacao v-model="documentosSolicitados"
                                                :documentos="documentos"
                                                class="mb-3"/>

      <painel-linha-fornecimento-visualizacao v-model="linhasFornecimento"/>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'
import PainelDocumentoSolicitadoVisualizacao from '@/views/pages/commons/detalhe-compra-direta/documentos/PainelDocumentoSolicitadoVisualizacao.vue'
import PainelLinhaFornecimentoVisualizacao from '@/views/pages/commons/detalhe-compra-direta/documentos/PainelLinhaFornecimentoVisualizacao.vue'

export default {
    name: 'DocumentosVisualizacao',
    components: {
        PainelDocumentoSolicitadoVisualizacao,
        PainelLinhaFornecimentoVisualizacao
    },
    data() {
        return {
            compraDiretaId: null,
            documentos: []
        }
    },
    computed: {
        ...mapState(['linhasFornecimento','documentosSolicitados']),
    },
    async mounted() {
        try {
            this.setCompraDiretaId()
            await this.buscarDocumentosDaProposta()
            await this.buscarDocumentosSolicitados()
            await this.buscarLinhasFornecimentoDaCompraDireta()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarDocumentosSolicitados() {
            await this.$store.dispatch(actionTypes.BUSCAR_DOCUMENTOS_SOLICITADOS, this.compraDiretaId)
        },
        async buscarDocumentosDaProposta() {
            await this.$store.dispatch(actionTypes.BUSCAR_DOCUMENTOS_PROPOSTA)
            this.documentos = this.$store.state.documentosProposta
        },
        async buscarLinhasFornecimentoDaCompraDireta() {
            await this.$store.dispatch(actionTypes.BUSCAR_LINHAS_DE_FORNECIMENTO_DA_COMPRA_DIRETA, this.compraDiretaId)
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        },
    }
}
</script>

<style scoped lang="stylus">

</style>